import { transformProduct } from './products';

export function transformCategoryAisles(
  categories,
  paginatedProductsPerCategory,
  tags,
  bundleOffersSummary,
  personalizedProductsIds,
  a
) {
  return (
    paginatedProductsPerCategory
      .map((i, index) => {
        const category = { ...categories[index], slugAscii: categories[index].fullSlug.replace('categories/', '') };
        delete category.subCategories;
        return {
          category,
          products:
            i?.map(product =>
              transformProduct(
                product,
                undefined,
                undefined,
                tags,
                bundleOffersSummary,
                undefined,
                undefined,
                undefined,
                personalizedProductsIds,
                a
              )
            ) || [],
        };
      })
      //filter out empty categories
      .filter(i => i.products.length > 0)
  );
}

export function fixUndefinedPosition(allCategories) {
  // Iterate through each category
  allCategories.forEach(category => {
    // Iterate through subcategories of the current category
    category.subcategories.forEach(subcategory => {
      // Check if the 'position' property is undefined and replace it with null
      if (subcategory.position === undefined) {
        subcategory.position = null;
      }
    });
  });

  return allCategories;
}
